import { store } from '../store'
import { SET_ACC_CLASS } from '../utils/constants'
import http from '../api/api'
import config from '../api/constants'

const getTermDepositAccounts = async () => {
  try {
    const reqParams = {
      accountType: 'D',
      requestId: 'ACCOUNTSUMMARY',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const getTenorLists = async () => {
  try {
    const reqParams = {
      requestId: 'TERMDEPOSITINTERESTRATES',
    }
    const response = await http.post(config.apiRoute.GET_TENOR_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getProducts = async () => {
  try {
    const reqParams = {
      requestId: 'TERMDEPOSITINTERESTRATES',
    }
    const response = await http.post(config.apiRoute.GET_PRODUCTS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getDepositCurrencyList = async () => {
  try {
    const reqParams = {
      requestId: 'CURRENCYLIST',
      module: '',
    }
    const response = await http.post(config.apiRoute.DEPOSIT_CURRENCY_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getRecurringDepositAccounts = async () => {
  try {
    const reqParams = {
      accountType: 'D',
      requestId: 'ACCOUNTSUMMARY',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getDepositAccountDetails = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'DEPOSITACCOUNTDETAILS',
    }
    const response = await http.post(config.apiRoute.GET_DEPOSIT_ACCOUNT_DETAILS, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getDepositTermsAndConditions = async () => {
  try {
    const reqParams = {
      requestId: 'TERMS',
      module: 'TD',
    }
    const response = await http.post(config.apiRoute.GET_TERMS_AND_CONDITIONS, reqParams)
    return response.data.termsCondition[0].message
  } catch (err) {
    throw err.response.data
  }
}

const createTermDeposit = async (data) => {
  try {
    let autoRollFlag = ''
    let rolloverType = ''
    if (data?.autoRenewal === 'CLOSE_ON_MATURITY') {
      autoRollFlag = 'Y'
      rolloverType = 'N'
    } else {
      autoRollFlag = 'N'
      rolloverType = data?.principle ? 'Y' : 'N'
    }
    const reqParams = {
      ...data,
      requestId: 'CREATETD',
      module: 'TERM_DEPOSITE',
      rolloverType: rolloverType,
      autoRollFlag: autoRollFlag,
    }
    const response = await http.post(config.apiRoute.CREATE_TERM_DEPOSIT, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const confirmTermDeposit = async (data) => {
  try {
    let autoRollFlag = ''
    let rolloverType = ''
    if (data?.autoRenewal === 'CLOSE_ON_MATURITY') {
      autoRollFlag = 'Y'
      rolloverType = 'N'
    } else {
      autoRollFlag = 'N'
      rolloverType = data?.principle ? 'Y' : 'N'
    }
    const reqParams = {
      ...data,
      requestId: 'CREATETDCONFIRM',
      rolloverType: rolloverType,
      autoRollFlag: autoRollFlag,
      principle:''
    }

    const response = await http.post(config.apiRoute.CREATE_TERM_DEPOSIT_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getDepositAccountStatement = async ({ srcAccount }) => {
  try {
    const reqParams = {
      srcAccount: srcAccount,
      module: 'TERM_DEPOSITE',
      requestId: 'TERMDEPOSITTENOR',
    }
    const response = await http.post(config.apiRoute.GET_DEPOSIT_STATEMENT, reqParams)
    return response
  } catch (err) {
    throw err.response.data
  }
}

const topupDepositVerify = async (data) => {
  try {
    const reqParams = {
      requestId: 'TOPUPTD',
      ...data,
    }
    const response = await http.post(config.apiRoute.TOP_UP_DEPOSIT_VERIFY, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const topupDepositConfirm = async (data) => {
  try {
    const reqParams = {
      termAccNo: data?.termAccNo,
      debitAccNo: data?.debitAccNo,
      debitAccBrn: data?.debitAccBrn,
      topupAmount: data?.topupAmount,
      accBrn: data?.accBrn,
      accCcy: data?.accCcy,
      requestId: 'TOPUPTDCONFIRM',
      remarks: data?.remarks,
      otpNo: data?.otp,
      randomKey: data?.randomKey,
    }
    const response = await http.post(config.apiRoute.TOP_UP_DEPOSIT_CONFIRM, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const redeemDepositVerify = async (data) => {
  try {
    const response = await http.post(config.apiRoute.REEDEM_DEPOSIT_VERIFY, {
      requestId: 'REDEEMTD',
      ...data,
    })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const redeemDepositConfirm = async (data) => {
  try {
    const reqParams = {
      termAccNo: data?.termAccNo,
      accBrn: data?.accBrn,
      accCcy: data?.accCcy,
      requestId: 'REDEEMTDCONFIRM',
      remarks: data?.remarks,
      otpNo: data?.otp,
      randomKey: data?.randomKey,
    }
    const response = await http.post(config.apiRoute.REEDEM_DEPOSIT_CONFIRM, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const DepositsService = {
  getTermDepositAccounts,
  getTenorLists,
  getDepositCurrencyList,
  getRecurringDepositAccounts,
  getDepositAccountDetails,
  getDepositTermsAndConditions,
  createTermDeposit,
  confirmTermDeposit,
  getDepositAccountStatement,
  topupDepositVerify,
  topupDepositConfirm,
  redeemDepositVerify,
  redeemDepositConfirm,
  getProducts
}

export default DepositsService
